import { TranslateHelperTypes } from './types'

export const BLOCK_URLS: string[] = [
  'doc.weixin.qq.com',
  'googleads.g.doubleclick.net',
  's1.hdslb.com',
  'oapi.dingtalk.com',
  'login.dingtalk.com',
  'imasdk.googleapis.com',
  'acdn.adnxs.com',
  'pos.baidu.com',
  'js-sec.indexww.com',
  'g.alicdn.com',
  'ads.pubmatic.com',
  'challenges.cloudflare.com',
  'accounts.google.com',
  'images-na.ssl-images-amazon.com',
  'tpc.googlesyndication.com',
  'js.stripe.com',
  'acdn.adnxs-simple.com',
  's.union.360.cn',
  's.amazon-adsystem.com',
  'www.recaptcha.net',
  's7.addthis.com',
  'z.moatads.com',
  'https://www.marketwatch.com/static_html/daa-min.html',
  'tr.snapchat.com',
  'ct.pinterest.com',
  '*.moatads.com',
  'secure-us.imrworldwide.com',
  'static.noeyeon.click',
  'widgets.outbrain.com',
  'www.dianomi.com/smartads.epl',
  'secure-assets.rubiconproject.com',
  'eus.rubiconproject.com',
  'eus.rubiconproject.com',
  'i.liadm.com',
  'eb2.3lift.com',
  'https://huiyiai.net',
  'https://huiyidev.miemie.la',
]

export const EXCLUDE_TAGS: string[] = [
  'TITLE',
  'SCRIPT',
  'STYLE',
  'TEXTAREA',
  'SVG',
  'svg',
  'G',
  'TEXT',
  'NOSCRIPT',
  'INPUT',
  'BASE',
  'SELECT',
  'OPTION',
  'IMG',
  'SUB',
  'SUP',
  'HR',
  'PRE',
  'CODE',
  'KBD',
  'WBR',
  'TT',
  'RT',
  'RP',
  'META',
  'MATH',
  'TTS-SENTENCE',
  'AIO-CODE',
]

const EXCLUDE_SELECTORS: string[] = [
  ...EXCLUDE_TAGS,
  '.ant-message',
  '[data-immersive-translate-effect]',
  '[contenteditable]',
  '.notranslate',
  '.monaco-editor',
  '.math-ignore',
]

const INCLUDE_SELECTORS: string[] = ['[contenteditable="false"]']

export const SITE_RULES: TranslateHelperTypes.SiteRule[] = [
  {
    matches: ['www.google.*/search*'],
    excludeSelectors: ['#bres', '[role="navigation"]'],
    globalStyles: {
      "div[data-content-feature='1'] > div":
        '-webkit-line-clamp: unset !important;max-height: unset !important;',
      "div[style='-webkit-line-clamp:2']":
        '-webkit-line-clamp: unset !important;max-height: unset !important;',
      "div[style='-webkit-line-clamp:3']":
        '-webkit-line-clamp: unset !important;max-height: unset !important;',
      "div[style='-webkit-line-clamp:4']":
        '-webkit-line-clamp: unset !important;max-height: unset !important;',
      '.related-question-pair': 'overflow:auto !important;',
    },
  },
  {
    matches: ['www.reddit.*/*'],
    excludeSelectors: [
      '.truncate',
      '[slot="credit-bar"]',
      '[data-testid="create-post"]',
      '[id*=search-community-title]',
      '.invisible',
    ],
    includeSelectors: ['.m\\:visible'],
    globalStyles: {
      '.line-clamp-1': '-webkit-line-clamp: unset !important;max-height: unset !important;',
      '.line-clamp-2': '-webkit-line-clamp: unset !important;max-height: unset !important;',
      '.line-clamp-3': '-webkit-line-clamp: unset !important;max-height: unset !important;',
      '[class*=huiyi]': 'visibility: visible !important',
    },
  },
  {
    matches: ['www.amazon.*/*'],
    excludeSelectors: ['nav'],
    globalStyles: {
      '.a-carousel-viewport': 'height:unset !important;',
      "[class*='clamp']": 'max-height: unset !important;-webkit-line-clamp: unset !important;',
      '[data-rows]': 'max-height: unset !important;-webkit-line-clamp: unset !important;',
      "[data-a-expander-name='review_text_read_more']": 'max-height: unset !important;',
      '.a-truncate': 'max-height: unset !important;',
      '.a-truncate-full':
        'position: relative !important;opacity: 1 !important;z-index: 1 !important;',
      '.a-truncate-cut': 'display: none !important;',
      '.octopus-dlp-asin-title':
        '-webkit-line-clamp: unset !important;max-height: unset !important;',
      '.fs-match-card': 'height: unset !important;',
      '.fs-match-card-title': '-webkit-line-clamp: unset !important;max-height: unset !important;',
      '.fs-match-card-desc': '-webkit-line-clamp: unset !important;max-height: unset !important;',
    },
  },
  {
    matches: ['twitter.com'],
    excludeSelectors: [
      '[aria-describedby][role=button]',
      "[data-testid='radioGroupplayback_rate'] div",
      "[data-testid='userFollowIndicator']",
    ],
  },
  {
    matches: ['pubmed.ncbi.nlm.nih.gov'],
    globalStyles: {
      '.docsum-title': 'display: inline-block !important;',
    },
    blockSelectors: ['.docsum-title'],
  },
  {
    matches: ['stackoverflow.com'],
    excludeSelectors: ['.comment-user'],
    blockSelectors: ['.comment-copy'],
  },
  {
    matches: ['www.perplexity.*/*'],
    globalStyles: {
      '.line-clamp-1': '-webkit-line-clamp: unset !important;max-height: unset !important;',
      '.line-clamp-2': '-webkit-line-clamp: unset !important;max-height: unset !important;',
      '.line-clamp-3': '-webkit-line-clamp: unset !important;max-height: unset !important;',
      '.line-clamp-4': '-webkit-line-clamp: unset !important;max-height: unset !important;',
      '.line-clamp-5': '-webkit-line-clamp: unset !important;max-height: unset !important;',
      '.line-clamp-6': '-webkit-line-clamp: unset !important;max-height: unset !important;',
    },
  },
  {
    matches: ['www.youtube.com'],
    excludeSelectors: ['.ytp-caption-window-container'],
    globalStyles: {
      '#video-title.ytd-compact-video-renderer':
        '-webkit-line-clamp: unset !important;max-height: unset !important;',
      '#snippet': 'max-height: unset !important;',
      'h1.ytd-watch-metadata': 'max-height: unset !important;',
    },
  },
  {
    matches: ['th.xiapibuy.com'],
    globalStyles: {
      '.Od5Z3o': '-webkit-line-clamp: unset !important;max-height: unset !important;',
    },
  },
  {
    matches: ['www.quora.com'],
    globalStylesV1: {
      '.qu-truncateLines--3': '-webkit-line-clamp: unset !important;',
      '.qu-truncateLines--1': '-webkit-line-clamp: unset !important;',
    },
  },
  {
    matches: ['frappeframework.com/docs/*'],
    globalStylesV1: {
      '.sidebar-items .sidebar-group-item': 'height:unset !important;',
      '.sidebar-group-container': 'height:unset !important;',
    },
    globalStyles: {
      '.sidebar-group-item-title': 'white-space:unset !important;overflow:unset !important;',
    },
  },
  {
    matches: ['app.jove.com/v/*'],
    excludeSelectors: ['.css-w7ike8', '.css-i3zic6'],
    globalStyles: {
      '.css-1eghtvj': '-webkit-line-clamp: unset !important;',
    },
  },
  {
    matches: ['workspace.google.com/marketplace*'],
    excludeSelectors: ['.google-material-icons'],
    globalStylesV1: {
      '.NJ5RBb': 'max-height:unset !important;',
    },
    reserveSelectors: ['PRE'],
  },
  {
    matches: ['www.producthunt.com/*'],
    globalStyles: {
      '.noOfLines-1': '-webkit-line-clamp: unset !important;',
      '.noOfLines-2': '-webkit-line-clamp: unset !important;',
      '.styles_description__iKXcL': 'height:unset !important;',
    },
    globalStylesV1: {
      '.styles_item__jJ01G': 'height:unset !important;',
    },
  },
  {
    matches: ['www.wordtune.com/lp*'],
    blockSelectors: ['.block-desktop .main-title', '.display-block'],
  },
  {
    matches: ['*.yahoo.com/*'],
    globalStyles: {
      '._ys_18rch03': 'white-space:unset !important;overflow:unset !important;',
    },
    globalStylesV1: {
      '[class*=LineClamp]': '-webkit-line-clamp: unset !important;max-height: unset !important;',
    },
  },
  {
    matches: ['modao.cc/*'],
    excludeSelectors: ['#workspace'],
  },
  {
    matches: ['www.linkedin.com/*'],
    excludeSelectors: ['.vjs-time-display'],
  },
  {
    matches: ['medium.com/*'],
    globalStyles: {
      '.jw': '-webkit-line-clamp: unset !important;',
      '.wl': '-webkit-line-clamp: unset !important;',
      '.oy': '-webkit-line-clamp: unset !important;',
      '.mg': '-webkit-line-clamp: unset !important;',
      '.ok': '-webkit-line-clamp: unset !important;',
      '.ml': '-webkit-line-clamp: unset !important;',
      '.jp': 'max-height:unset !important;',
      '.jm': 'max-height:unset !important;',
      '.os': 'max-height:unset !important;',
      '.mk': 'max-height:unset !important;',
      '.oj': 'max-height:unset !important;',
      '.vb': 'max-height:unset !important;',
      '.ox': 'max-height:unset !important;',
      '.jv': 'max-height:unset !important;',
      '.lu': 'max-height:unset !important;',
      '.zr': 'max-height:unset !important;',
      '.sj': 'max-height:unset !important;',
    },
  },
  {
    matches: ['x.com/*'],
    globalStyles: {
      '*': '-webkit-line-clamp:unset !important;',
    },
  },
  {
    matches: ['webvpn.bnu.edu.cn/*', 'www.sciencedirect.com/*'],
    inlineSelectors: ['.anchor-text-container', '.u-display-inline-flex'],
  },
  {
    matches: ['www.mdpi.com/*'],
    reserveSelectors: ['SUB', 'SUP'],
    blockSelectors: ['.html-p'],
  },
  {
    matches: ['search.cisco.com/search*'],
    globalStyles: {
      '.dispInline[_ngcontent-c21]': '-webkit-line-clamp:unset !important;',
      '.txt-desc[_ngcontent-c21]': '-webkit-line-clamp:unset !important;',
    },
  },
  {
    matches: ['www.webofscience.com/wos/woscc/summary/*'],
    globalStylesV1: {
      '.summary-record .abstract': 'height:unset !important;',
    },
  },
  {
    matches: ['news.slashdot.org/story/*'],
    globalStylesV1: {
      '#comments .oneline > div > div.commentBody': 'height:unset !important;',
    },
  },
]

export const TRANSLATE_HELPER_CONFIG: TranslateHelperTypes.Config = {
  area: 'all',
  blockUrls: BLOCK_URLS,
  enableUrls: ['https://huiyiai.net/welcome', 'https://huiyidev.miemie.la/welcome'],
  globalStyles: {},
  globalStylesV1: {},
  containerSelectors: [],
  excludeSelectors: EXCLUDE_SELECTORS,
  includeSelectors: INCLUDE_SELECTORS,
  inlineSelectors: [],
  blockSelectors: [],
}
